import { CompactAudioRefInstance } from '@doltech/ui/lib/figma/Audio/Player/CompactAudioPlayer';
import { colorsV2 } from '@doltech/ui/lib/figma/colors-v2';
import {
  SectionOfContent,
  SectionOfContentProps,
} from '@doltech/ui/lib/figma/Layout/Landing/Content/SectionOfContent';
import { deviceBreakpoints } from '@doltech/ui/lib/hooks/useDeviceQuery.hook';
import { ScriptTypeEnum } from '@doltech/utils/lib/constants';
import * as React from 'react';
import { useInView } from 'react-cool-inview';
import styled from 'styled-components';

import { useViewTestSubjectStore } from '../../view-test-subject/model/view-test-subject.hook';
import { TranscriptConversationContent } from './TranscriptConversationContent';
import { TranscriptMonologContent } from './TranscriptMonologContent';

const Main = styled.section`
  margin-bottom: 40px;

  .audio-wrapper {
    padding: 8px 24px;
    background-color: ${colorsV2.gray5};

    @media ${deviceBreakpoints.mobile} {
      padding: 8px 16px;
    }
  }
`;

interface TranscriptSectionProps extends Pick<SectionOfContentProps, 'renderTitle'> {
  sectionName: string;
  type: ScriptTypeEnum;
  sectionIndex?: number;
  script: any;
}

export const TranscriptSection = (props: TranscriptSectionProps) => {
  const { script, type, sectionIndex, sectionName, renderTitle } = props;
  const store = useViewTestSubjectStore();
  const tableOfContent = store.getTableOfContent();
  const audioRef = React.useRef<CompactAudioRefInstance>();
  const { observe } = useInView({
    threshold: [0.2, 0.8],
    onLeave: () => {
      if (audioRef?.current?.pause) {
        audioRef.current.pause();
      }
    },
  });

  return (
    <div ref={observe as any} id={`transcript-section-${sectionIndex}`}>
      <Main className="test-section-container">
        <SectionOfContent
          sectionId={`transcript-section-${sectionIndex}`}
          tableOfContent={tableOfContent}
          renderTitle={renderTitle}
        >
          <SectionOfContent.Header>
            <div className="title">{sectionName}</div>
          </SectionOfContent.Header>
          <SectionOfContent.Content>
            {type === ScriptTypeEnum.MONOLOG ? (
              <TranscriptMonologContent script={script} />
            ) : (
              <TranscriptConversationContent script={script} />
            )}
          </SectionOfContent.Content>
        </SectionOfContent>
      </Main>
    </div>
  );
};
